import * as legacyStudyPlanApi from "api/legacy_study_plan";

import { RequestResponse } from "utils/base_api";

import { useQuery } from "react-query";

import { Topic } from "types/topic";

type LessonsCountT = {
  count: number;
  isLoading: boolean;
};

export default function useLessonsCount(
  subjectSlug: string,
  topicSlug: string,
  enabled: boolean
): LessonsCountT {
  const isLackingClassification = !subjectSlug || !topicSlug;
  const { data: response, isLoading } = useQuery(
    ["lessonsCount", subjectSlug],
    () => legacyStudyPlanApi.subtopics(subjectSlug),
    { enabled: enabled && !isLackingClassification }
  );
  const lessonsCount = isLackingClassification
    ? 0
    : lessonsCountFromResponse(response, topicSlug);

  return {
    count: lessonsCount,
    isLoading
  };
}

function lessonsCountFromResponse(
  response: RequestResponse,
  topicSlug: string
) {
  if (!response) return;

  const children = response.body.children;
  const subtopicResponse = children.find((child: Topic) => {
    return child.slug === topicSlug;
  });

  const count = subtopicResponse?.lessons?.total || 0;
  return count;
}
